import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessKnowledgeRoute: InvariantJiraRoute = {
	name: 'classic-business-knowledge',
	exact: true,
	path: '/jira/core/projects/:projectKey/knowledge',
};
